module.exports = __webpack_public_path__ + "img/zhanli10.9faeb2ae.jpg";